<div class="pane-container">
  <app-till-overview title="Tills" (selection)="onShortcut($event)"></app-till-overview>
  <app-action-pane [hint]="['Identifier', 'Name']" (action)="onAction($event)"
    (magic)="onSearch({ magic: $event})"></app-action-pane>
</div>
<div *ngIf="creation; then showForm else showList"></div>
<ng-template #showForm>
  <app-till-form [creation]="true" [creation]="true" [mode]="Mode.edition" [object]="till" (event)="onEvent($event)"></app-till-form>
</ng-template>
<ng-template #showList>
  <app-till-list #list [sorting]="sorting" (event)="onEvent($event)" (sort)="onSort($event)"></app-till-list>
</ng-template>
